import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Content } from '../../../../../../components/HotelDetailsOverlay/components/DescriptionSection/components/TextBlock/components/Content.js';
import { Stack } from '../../../../../../primitives/index.js';
export const TextBlock = ({
  title,
  children
}) => {
  return _jsxs(Stack, {
    spacing: "small",
    children: [title, children && _jsx(Content, {
      dangerouslySetInnerHTML: {
        __html: children
      }
    })]
  });
};